<div>
  <mat-card *ngFor="let casino of casinoList" class="casino-card" (click)="openGame(casino)">
    <mat-card-header>
      <mat-card-title>{{ casino.GameName }}</mat-card-title>
      <mat-card-subtitle>{{ casino.SubType }}</mat-card-subtitle>
    </mat-card-header>
    <img mat-card-image src="{{ casino.Thumbnail?.indexOf('http') > -1 ? casino.Thumbnail : '/images/b500/casino/' + casino.Thumbnail }}" />
    <mat-card-actions>
      <button mat-button>{{ 'play' | t }}</button>
    </mat-card-actions>
  </mat-card>
</div>
